import React, { useState } from "react";
import { getIn } from "formik";
import { Box, TextField, InputAdornment, Typography, InputLabel } from "@mui/material";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import ReactQuill from 'react-quill-new';
import 'react-quill-new/dist/quill.snow.css';




export const FormikQuillField = ({ field, form, label, isRequired, isFull = false }) => {
    const errorText = getIn(form.touched, field.name) && getIn(form.errors, field.name);
    const [showQuill, setShowQuill] = useState(false);
    const handleOpenQuill = () => setShowQuill(true);
    const handleChange = (value) => {
        form.setFieldValue(field.name, value);
    };

    return (
        <Box>
            {label && (
                <InputLabel sx={{ textTransform: "capitalize" }} shrink htmlFor={field.name}>
                    <Typography variant="body1">
                        {label}
                        {isRequired && (
                            <Typography variant="body1" color="error" component="span">
                                {" *"}
                            </Typography>
                        )}
                    </Typography>
                </InputLabel>
            )}
            {!showQuill ? (
                <Box sx={{ width: "100%" }}>
                    <TextField
                        variant="standard"
                        placeholder={`Add ${label}` || "Add Heading"}
                        fullWidth
                        value={field.value || ""}
                        onChange={(e) => handleChange(e.target.value)}
                        InputProps={{
                            disableUnderline: true,
                            endAdornment: (
                                <InputAdornment position="end">
                                    <FilterAltOutlinedIcon
                                        sx={{
                                            color: "blue.main",
                                            fontSize: "1.5rem",
                                            cursor: "pointer",
                                        }}
                                        onClick={handleOpenQuill}
                                    />
                                </InputAdornment>
                            ),
                            sx: {
                                fontSize: "0.9rem",
                                fontWeight: 400,
                                color: "text.primary",
                                minHeight: "60px",
                                borderRadius: "5px",
                                border: "1px solid #4169E1",
                                padding: "12px 10px",
                                backgroundColor: "#F7FAFF",
                                boxSizing: "border-box",
                            },
                        }}
                    />
                    {errorText && (
                        <Typography variant="h6" fontSize="10px" color="red" mt={0.5}>
                            {errorText}
                        </Typography>
                    )}
                </Box>
            ) : (
                <Box
                    sx={{
                        width: "100%",
                        height: isFull ? "100vh" : "auto",
                        "& .ql-container": {
                            borderRadius: "0 0 5px 5px",
                            border: "1px solid #4169E1",
                            backgroundColor: "#F7FAFF",
                            ...(isFull ? { height: "calc(100vh - 50px)" } : {}),
                        },
                        "& .ql-editor": {
                            fontSize: "1rem",
                            color: "text.primary",
                            ...(isFull ? { height: "100%", minHeight: "100%" } : { minHeight: "100px" }),
                        },
                        "& .ql-toolbar": {
                            borderRadius: "5px 5px 0 0",
                        },
                    }}
                >

                    {/* <ReactQuill
                        theme="snow"
                        value={field.value || ""}
                        onChange={handleChange}
                        modules={{
                            toolbar: [
                                [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                ["bold", "italic", "underline", "strike"],
                                [{ list: "ordered" }, { list: "bullet" }],
                                [{ color: [] }, { background: [] }],
                                [{ align: [] }],
                                ["link"],
                                ["clean"],
                            ],
                        }}
                     
                    /> */}
                    <ReactQuill
                        theme="snow"
                        value={field.value || ""}
                        onChange={handleChange}
                        modules={{
                            toolbar: {
                                container: [
                                    [{ header: [1, 2, 3, 4, 5, 6, false] }],
                                    ["bold", "italic", "underline", "strike"],
                                    [{ list: "ordered" }, { list: "bullet" }],
                                    [{ color: [] }, { background: [] }],
                                    [{ align: [] }],
                                    ["link", "image"],
                                    ["clean"],
                                ],
                                // handlers: {
                                //     image: function () {
                                //         const input = document.createElement("input");
                                //         input.setAttribute("type", "file");
                                //         input.setAttribute("accept", "image/*");
                                //         input.click();

                                //         input.onchange = async () => {
                                //             const file = input.files[0];
                                //             if (file) {
                                //                 const formData = new FormData();
                                //                 formData.append("file", file);
                                //                 formData.append("upload_preset", "YOUR_CLOUDINARY_PRESET");

                                //                 try {
                                //                     const res = await fetch(
                                //                         `https://api.cloudinary.com/v1_1/YOUR_CLOUD_NAME/image/upload`,
                                //                         {
                                //                             method: "POST",
                                //                             body: formData,
                                //                         }
                                //                     );
                                //                     const data = await res.json();
                                //                     const range = this.quill.getSelection();
                                //                     this.quill.insertEmbed(range.index, "image", data.secure_url);
                                //                 } catch (err) {
                                //                     console.error("Image upload failed:", err);
                                //                 }
                                //             }
                                //         };
                                //     },
                                // },
                            },
                        }}
                    />

                    {errorText && (
                        <Typography variant="h6" fontSize="10px" color="red" mt={0.5}>
                            {errorText}
                        </Typography>
                    )}
                </Box>
            )}
        </Box>
    );
};
